import React, {Component} from 'react';

import '../../css/FullscreenPopover.css';

class FullscreenPopover extends Component {
    constructor(props) {
        super(props);
        this.state = {
            animateOut: false
        }
    }

    animateOut = () => {
        this.setState({
            animateOut: true
        });
        window.setTimeout(this.props.onClose, 500);
    }

    render() {
        return (
            <div className={"fullscreen-popover-container" + (this.state.animateOut ? " fullscreen-popover-container-exit" : "")}>
                <this.props.childClass {...this.props} animateOut={this.animateOut} />
            </div>
        )
    }
}

export default FullscreenPopover;



// WEBPACK FOOTER //
// ./src/components/common/FullscreenPopover.js